import { FileUploadProps, Files } from "./FileUploader.types";

import StyledWrapper from "./style";
import { useState } from "react";

const KILO_BYTES_PER_BYTE = 1000;

const convertBytesToKB = (bytes: number) =>
  Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInBytes,
  accept,
  multiple,
  imageFile,
  ...otherProps
}: FileUploadProps) => {
  const [files, setFiles] = useState<Files>({});

  const addNewFiles = (newFiles: FileList): Files => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        //TODO: Resolve Types
        /* @ts-ignore */
        if (!multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const convertNestedObjectToArray = (nestedObj: Files) =>
    Object.keys(nestedObj).map((key) => nestedObj[key]);

  const callUpdateFilesCb = (files: Files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleNewFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files: newFiles } = e.target;
    if (!!newFiles) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }
  };

  const removeFile = (fileName: string) => {
    delete files[fileName];
    setFiles({ ...files });
    callUpdateFilesCb({ ...files });
  };

  return (
    <>
      {Object.keys(files).length === 0 ? (
        <StyledWrapper.BoxWithFiles>
          <input
            type="file"
            onChange={handleNewFileUpload}
            className="hidden"
            accept={accept}
            {...otherProps}
          />
          <span className={`max-w-39 max-h-35 mr-5 ${imageFile && 'pl-5'} `}>
            <img id="file-image" src={imageFile ? imageFile : `/images/Upload.svg `} alt="Preview" />
          </span>
          <div>
            <p>{label}</p>
            {!imageFile ? <StyledWrapper.MaxCapacity>
              Límite de {maxFileSizeInBytes >= 1024 * 1024
                ? `${Math.round(maxFileSizeInBytes / (1024 * 1024))}MB`
                : `${Math.round(maxFileSizeInBytes / 1000)}kB`}
            </StyledWrapper.MaxCapacity> : ""}
          </div>
        </StyledWrapper.BoxWithFiles>
      ) : (
        <StyledWrapper.BoxWithoutFiles>
          {Object.keys(files).map((fileName) => {
            let file = files[fileName];
            return (
              <div key={fileName}>
                <span  className="px-1">
                  {file.name}
                  <StyledWrapper.Capacity>
                    ({convertBytesToKB(file.size)}kB)
                  </StyledWrapper.Capacity>
                </span>
                <button type="button" onClick={() => removeFile(fileName)} className="ml-2">
                  <img id="file-image" src="/images/CrossRed.svg" alt="Cross" />
                </button>
              </div>
            );
          })}
        </StyledWrapper.BoxWithoutFiles>
      )}
    </>
  );
};
export default FileUpload;
